/**
 * Mobility MVP: Quiz Completion Screen
 * Success state after completing the mobility questionnaire
 * Follows FIGMA #MVP-Success-01 pattern
 */

import { CheckCircle2 } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

interface MobilityQuizCompleteProps {
  onContinue: () => void;
  onSkip: () => void;
}

export function MobilityQuizComplete({ onContinue, onSkip }: MobilityQuizCompleteProps) {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="max-w-[420px] w-full">
        <CardContent className="pt-6 pb-6">
          <div className="flex flex-col items-center text-center space-y-6">
            {/* Large green checkmark */}
            <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center">
              <CheckCircle2 className="h-12 w-12 text-green-600" />
            </div>

            {/* Success message */}
            <div className="space-y-2">
              <h2 className="text-2xl font-semibold">Mobility profile updated</h2>
              <p className="text-sm text-muted-foreground">
                You can retake these questions anytime.
              </p>
            </div>

            {/* Action buttons */}
            <div className="w-full space-y-3 pt-4">
              <Button onClick={onContinue} className="w-full" size="lg">
                Continue → Pelvic Tilt Test
              </Button>
              <Button onClick={onSkip} variant="outline" className="w-full" size="lg">
                Skip for now
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
